export enum HeaderTable {
  titleForBrandTable = 'Putni Nalog',
}

// export enum HeaderColumns {
//   brandname = 'Naziv',  
// }

export enum ModalForAddOrUpdateTravelOrder {
  titleForAddTravelOrder = 'Dodavanje novog putnog naloga',
  titleForUpdateTravelOrder = 'Izmena putnog naloga',
  travelOrderNameEmpty = 'Potrebno je uneti putni nalog.',
  travelOrderNamePlaceholder = 'Putni nalog',
  saveSuccessMessage = 'Novi putni nalog je uspešno sačuvan.',
  updateSuccessMessage = 'Putni nalog je uspešno izmenjen.',
  deleteSuccessMessage = 'Putni nalog je uspešno obrisan.',
}